import SparkMD5 from 'spark-md5';

/**
 * MD5 digest as 16 raw bytes (for TrustLine UUID v3 action IDs).
 */
export function md5Bytes(input: string): Uint8Array {
  const hex = SparkMD5.hash(input);
  const out = new Uint8Array(16);
  for (let i = 0; i < 16; i += 1) {
    out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  }
  return out;
}
